import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      gap: '4px',
    },
  },
  label: {
    fontSize: '16px',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  switch: {
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: '#fff',
        '& .MuiSwitch-thumb': {
          backgroundColor: '#0096D6',
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#E0E0E0',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#0096D6',
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: '#E0E0E0',
      borderRadius: 20,
    },
  },
}))
